module.exports = __webpack_public_path__ + "assets/img/image-55-640.4b1b104c.webp";